<template>
  
    <ion-menu
    menu-id="custom"
      type="overlay"
      id="mysidebar"
      fixed
      :minimize="minimize"
      :show.sync="show"
      side="start"
      content-id="main-content"
    >
      <ion-content v-if="nav && nav.length!=0">
        <div class="c-sidebar-brand" >
            <a rel="noopener">
              <span class="side-bar-brand-logo-full"></span>
              <span class="side-bar-brand-logo-minimized"></span>
            </a>
          </div>
          <span class="brand-logo-mob c-header-brand mx-auto d-lg-none"></span>
        <div v-for="(items,index ) in nav[0]._children" :key="index+'sideBar'">
         
          <ion-menu-toggle v-if="items._name=='CSidebarNavItem'">
            <ion-item>
              <span @click="goTo(items.to)">{{items.name}}</span>
            </ion-item>
          </ion-menu-toggle>
          
            <ion-item v-else @click="items.isOpen=!items.isOpen">
              <ion-icon slot="start" name="arrow-forward" v-if="!items.isOpen"></ion-icon>
              <ion-icon slot="start" name="arrow-down" v-if="items.isOpen"></ion-icon>
              <span>{{items.name}}</span>
            </ion-item>
            
          <ion-list v-if="items.items && items.items.length>0 && items.isOpen" >
            <div v-for="(children,cindex) in items.items" :key="cindex+'submenu'">
               <ion-menu-toggle>
              <ion-item @click="goTo(children.to)">
                {{children.name}}
              </ion-item>
              </ion-menu-toggle>
            </div>
        </ion-list>
        </div>
        <!-- <ion-menu-toggle > -->
          <!-- <div class="c-sidebar-brand" @click="goTo()">
            <a rel="noopener">
              <span class="side-bar-brand-logo-full"></span>
              <span class="side-bar-brand-logo-minimized"></span>
            </a>
          </div>
          <span class="brand-logo-mob c-header-brand mx-auto d-lg-none"></span> -->
          <!-- <CRenderFunction flat :content-to-render="nav" /> -->
        <!-- </ion-menu-toggle> -->
       
      </ion-content>
    </ion-menu>
    <!-- <div id="main-content">
      <CHeader :fixed="isFixedHeader" :with-subheader="false" light class="flex-flow-unset">
        <div class="cus-header-main">
          <div class="search-flight-wrapper w-100">
            <div class="wrapper">
              <div class="menu">
                <ul>
                  <li @click="navToDashBoard()">
                    <span>{{$t('header.dashboard')}}</span>
                  </li>
                  <li @click="navToMyBookingPage()">
                    <span>{{$t('header.mybooking')}}</span>
                  </li>
                  <li @click="navToTicketingPage()">
                    <span>{{$t('header.ticktQue')}}</span>
                  </li>
                </ul>
              </div>

              <div class="d-flex h-search-wrap">
                <TheHeaderDropdownAccnt style="list-style: none;" />
              </div>
            </div>
          </div>
        </div>

        <ion-menu-button></ion-menu-button>
        <span class="brand-logo-center c-header-brand mx-auto d-lg-none"></span>
        <CHeaderNav class="d-md-down-none mr-auto"></CHeaderNav>
      </CHeader>
    </div> -->
 
</template>
<script>
import router, { navigate, goBack, navigateReplace } from "../../router/index";
import TheHeaderDropdownAccnt from "../../containers/TheHeaderDropdownAccnt";
export default {
  name: "aSideMenu",
  props: {
    nav: {
      type: Object | Array,
      default: null
    },
    minimize: {
      type: Boolean,
      default: false
    },
    isFixedHeader: {
      type: Boolean,
      default: false
    },
    show: {
      type: String | Boolean,
      default: "responsive"
    }
  },
  components: {
    TheHeaderDropdownAccnt
  },
  methods: {
    goTo(url) {
      navigate(url);
    }
  }
};
</script>